import { createSelector } from '@reduxjs/toolkit';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';

const applicationUserProjections = {} as ObjectOfAny;

applicationUserProjections.applicationUserFullName = createSelector(
    (state: RootState) => state.applicationUser.applicationUserDetails,
    applicationUserDetails => {
        return applicationUserDetails && applicationUserDetails.fullName
            ? applicationUserDetails.fullName
            : '';
    },
);

applicationUserProjections.selectIsModalOpen = createSelector(
    (state: RootState) => state.applicationUser,
    applicationUser => {
        //Prevent opening the Language modal in review claim
        if (
            !applicationUser ||
            Object.keys(applicationUser.applicationUserDetails).length === 0
        ) {
            return false;
        }
        const { updateConsent, requestHasFailed } = applicationUser;

        if (!updateConsent && !requestHasFailed) {
            return true;
        } else if (!updateConsent && requestHasFailed) {
            return true;
        } else {
            return false;
        }
    },
);

applicationUserProjections.selectAreTermsConsented = createSelector(
    (state: RootState) => state.applicationUser.applicationUserDetails,
    applicationUserDetails => {
        return applicationUserDetails &&
            applicationUserDetails.areTermsConsented
            ? applicationUserDetails.areTermsConsented
            : '';
    },
);
export default applicationUserProjections;
